<template>
   <div class="liquidacionComisiones">
      <div class="titlePage">
         Liquidación de Comisiones
      </div>
      <!-- MODALES -->
      <ModalOperador
         :show="showModalOperator"
         :title="titleModal"
         :infoOperatorArray="infoOperators"
         @close="closeModalOperator"
         @nextModal="nextModal"
         />
      <ModalOperador2
         :show="showModalOperator2"
         :title="titleModal2"
         :infoAnuladosArray="infoAnulados"
         @close="closeModalOperator2"
         @nextModalAnulados="nextModalAnulados"
         />
      <ModalOperador3
         :show="showModalOperator3"
         :title="titleModal3"
         :infoAnuladosvsConsolidado="infoAnuladosvsConsolidado"
         @close="closeModalOperator3"
         @nextModalAnuladosvsConsolidado="nextModalAnuladosvsConsolidado"
         />
      <ModalOperador4
         :show="showModalOperator4"
         :title="titleModal4"
         :infoAnuladosvsConsolidadop2="infoAnuladosvsConsolidadop2"
         @close="closeModalOperator4"
         @nextModalAnuladosvsConsolidadop2="nextModalAnuladosvsConsolidadop2"
         />
      <ModalOperador5
         :show="showModalOperator5"
         :title="titleModal5"
         :infoFinalReportPreComision="infoFinalReportPreComision"
         :infoFinalReportPDComision="infoFinalReportPDComision"
         @close="closeModalOperator5"
         />
      <ModalUpdateInfo
         :show="showModalUpdateInfo"
         :title="titleModalUpdateInfo"
         @close="closeModalUpdateInfo"
         />
      <!-- BOTON UPDATE -->
      <div class="update-screen">
         <ButtonUpdate @click="showModalUpdateInfoMethod" />
      </div>
      <!-- PANTALLA INICIAL -->
      <div class="initial-screen">
         <!-- <Fecha @update-dates="handleDates"/> -->
         <InputOperador
            @update-operator-text="handleOperatorText"
            />
         <ButtonSend
            @click="handleButtonSendDatesAndOperator"
            />
      </div>
   </div>
</template>
<script>
// Importa el componente hijo
import IberoHelpers from '@/store/helpers.js'
import Fecha from './inputFechas.vue'
import ButtonSend from './boton.vue'
import ButtonUpdate from './botonUpdate.vue'
import InputOperador from './inputText.vue'
import ModalOperador from './modal.vue'
import ModalOperador2 from './modal2.vue'
import ModalOperador3 from './modal3.vue'
import ModalOperador4 from './modal4.vue'
import ModalOperador5 from './modal5.vue'
import ModalUpdateInfo from './modalUpdateInfo.vue'

export default {
  components: {
    IberoHelpers,
    Fecha,
    ButtonSend,
    ButtonUpdate,
    InputOperador,
    ModalOperador,
    ModalOperador2,
    ModalOperador3,
    ModalOperador4,
    ModalOperador5,
    ModalUpdateInfo,
  },
  data () {
    return {
      startDate: '',
      endDate: '',
      operator: '',
      showModalOperator: false,
      showModalOperator2: false,
      showModalOperator3: false,
      showModalOperator4: false,
      showModalOperator5: false,
      showModalUpdateInfo: false,
      titleModal: '',
      titleModal2: '',
      titleModal3: '',
      titleModal4: '',
      titleModal5: '',
      titleModalUpdateInfo: '',
      infoOperators: [],
      infoAnulados: [],
      infoAnuladosvsConsolidado: [],
      infoAnuladosvsConsolidadop2: [],
      infoFinalReportPreComision: [],
      infoFinalReportPDComision: [],
    }
  },
  methods: {

    handleDates (dates) {
      this.startDate = dates.startDate
      this.endDate = dates.endDate
    },
    handleOperatorText (operator) {
      this.operator = operator
    },
    // handleButtonSendDatesAndOperator () {
    //   if (this.operator != '') {
    //     IberoHelpers.GetEmptyOpList(this.$store, this.operator)
    //       .then((response) => {
    //         this.infoOperators = response.data
    //         // Abre el modal solo después de cargar los datos
    //         this.titleModal = 'Validación de Operadores'
    //         this.showModalOperator = true
    //       })
    //       .catch((error) => {
    //         console.error('Error loading data:', error)
    //         // Opcional: manejar errores, como mostrar un mensaje de error al usuario
    //       })
    //   }
    // },

    handleButtonSendDatesAndOperator () {
      if (this.operator !== '') {
        IberoHelpers.GetEmptyOpList(this.$store, this.operator)
          .then((response) => {
            this.infoOperators = response.data || [] // Asegura que siempre sea un array
            this.titleModal = 'Validación de Operadores'
            this.showModalOperator = true // Abre el modal incluso si los datos están vacíos
          })
          .catch((error) => {
            console.error('Error loading data:', error)
          // Opcional: manejar errores, como mostrar un mensaje de error al usuario
          })
      }
    },
    closeModalOperator () {
      this.showModalOperator = false
    },
    closeModalOperator2 () {
      this.showModalOperator2 = false
    },
    closeModalOperator3 () {
      this.showModalOperator3 = false
    },
    closeModalOperator4 () {
      this.showModalOperator4 = false
    },
    closeModalOperator5 () {
      this.showModalOperator5 = false
    },
    closeModalUpdateInfo () {
      this.showModalUpdateInfo = false
    },
    nextModal () {
      IberoHelpers.GetNullList(this.$store, this.operator)
        .then((response) => {
          this.infoAnulados = response.data
          // Abre el modal solo después de cargar los datos
          this.showModalOperator = false
          this.titleModal2 = 'Validación Ordenes Anuladas'
          this.showModalOperator2 = true
        })
        .catch((error) => {
          console.error('Error loading data:', error)
          // Opcional: manejar errores, como mostrar un mensaje de error al usuario
        })
    },
    nextModalAnulados () {
      IberoHelpers.GetAnuladosvsConsolidado(this.$store, this.operator)
        .then((response) => {
          this.infoAnuladosvsConsolidado = response.data
          // Abre el modal solo después de cargar los datos
          this.showModalOperator2 = false
          this.titleModal3 = 'Validación Anulados vs Consolidado'
          this.showModalOperator3 = true
        })
        .catch((error) => {
          console.error('Error loading data:', error)
          // Opcional: manejar errores, como mostrar un mensaje de error al usuario
        })
    },
    nextModalAnuladosvsConsolidado () {
      IberoHelpers.GetAnuladosvsConsolidadoP2(this.$store, this.operator)
        .then((response) => {
          this.infoAnuladosvsConsolidadop2 = response.data
          // Abre el modal solo después de cargar los datos
          this.showModalOperator3 = false
          this.titleModal4 = 'Validación Anulados vs Consolidado P2'
          this.showModalOperator4 = true
        })
        .catch((error) => {
          console.error('Error loading data:', error)
          // Opcional: manejar errores, como mostrar un mensaje de error al usuario
        })
    },
    nextModalAnuladosvsConsolidadop2 () {
      IberoHelpers.GetFinalReportPreComision(this.$store, this.operator)
        .then((response) => {
          console.log(response.data, 'prueba')
          this.infoFinalReportPreComision = response.data
          this.nextModalPD()
        })
        .catch((error) => {
          console.error('Error loading data:', error)
          // Opcional: manejar errores, como mostrar un mensaje de error al usuario
        })
    },
    nextModalPD () {
      IberoHelpers.GetFinalReportPreComisionPD(this.$store, this.operator)
        .then((response) => {
          console.log(response.data, 'prueba2')
          this.infoFinalReportPDComision = response.data
          // Abre el modal solo después de cargar los datos
          this.showModalOperator4 = false
          this.titleModal5 = 'Descarga Archivo'
          this.showModalOperator5 = true
        })
    },
    nextModalGetFinalReportPreComision () {
      this.showModalOperator5 = false
    },
    showModalUpdateInfoMethod () {
      this.showModalUpdateInfo = true
    },

  },
}
</script>